import { computed, defineAsyncComponent } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import type { ComponentMapType } from '@/types/composables/DynamicComponentTypes';

const SuperAdminLayout = defineAsyncComponent(() => import('@/apps/super-admin/SuperAdminLayout.vue'));
const CompanyAdminLayout = defineAsyncComponent(() => import('@/apps/company-admin/CompanyAdminLayout.vue'));

export function useDynamicComponent(componentMap: ComponentMapType) {
    const authStore = useAuthStore();

    const isElevatedUser = computed(() => authStore.user?.is_super_admin || authStore.user?.is_integrator);

    const currentComponent = computed(() => {
        if (isElevatedUser.value && componentMap['super-admin']) {
            return componentMap['super-admin'];
        }
        if (componentMap['company-admin']) {
            return componentMap['company-admin'];
        }

        return componentMap.fallback || null;
    });

    const currentLayout = computed(() => {
        if (isElevatedUser.value) {
            return SuperAdminLayout;
        }

        return CompanyAdminLayout;
    });

    return {
        currentComponent,
        currentLayout,
    };
}
